export function transformToUpdateCampaignRequestPayload(updatedCampaign, campaign) {
    const requestPayload = {
        id: campaign.id,
        status: campaign.status,
        operations: buildOperations(updatedCampaign, campaign),
    };
    return requestPayload;
}
function buildOperations(updatedCampaign, campaign) {
    return {
        additions: buildAddOperations(updatedCampaign, campaign),
        removals: buildRemoveOperations(updatedCampaign, campaign),
        updations: buildUpdateOperations(updatedCampaign, campaign),
    };
}
function buildAddOperations(updatedCampaign, campaign) {
    const additions = {};
    // adGroupCandidates check
    for (const updatedCandidate of updatedCampaign.adGroups[0].candidates) {
        if (!campaign.adGroups[0].candidates.find((candidate) => updatedCandidate.id === candidate.id)) {
            if (!additions.adGroupCandidates) {
                additions.adGroupCandidates = [
                    {
                        adGroupId: campaign.adGroups[0].id,
                        ids: [updatedCandidate.id],
                    },
                ];
            }
            else {
                additions.adGroupCandidates[0].ids.push(updatedCandidate.id);
            }
        }
    }
    return additions;
}
function buildRemoveOperations(updatedCampaign, campaign) {
    const removals = {};
    // adGroupCandidates check
    for (const candidate of campaign.adGroups[0].candidates) {
        if (!updatedCampaign.adGroups[0].candidates.find((updatedCandidate) => updatedCandidate.id === candidate.id)) {
            if (!removals.adGroupCandidates) {
                removals.adGroupCandidates = [
                    {
                        adGroupId: campaign.adGroups[0].id,
                        adIds: [candidate.adId],
                    },
                ];
            }
            else {
                removals.adGroupCandidates[0].adIds.push(candidate.adId);
            }
        }
    }
    return removals;
}
function buildUpdateOperations(updatedCampaign, campaign) {
    const updations = {};
    // campaign name check
    if (updatedCampaign.name.trim() !== campaign.name.trim()) {
        updations.name = updatedCampaign.name.trim();
    }
    // budget and pacing check
    if (updatedCampaign.budget !== campaign.budget ||
        updatedCampaign.pacingEnabled !== campaign.pacingEnabled) {
        updations.budget = updatedCampaign.budget;
        updations.pacingEnabled = updatedCampaign.pacingEnabled;
    }
    // startDate check & endDate check
    if (updatedCampaign.startDate !== campaign.startDate ||
        updatedCampaign.endDate !== campaign.endDate) {
        updations.startDate = updatedCampaign.startDate;
        updations.endDate = updatedCampaign.endDate;
    }
    // placement Ids check
    const buildPlacementIdsOperation = () => {
        updations.placementIds = updatedCampaign.placementIds;
    };
    if (updatedCampaign.placementIds.length !== campaign.placementIds.length) {
        buildPlacementIdsOperation();
    }
    else {
        for (const placementId of updatedCampaign.placementIds) {
            if (!campaign.placementIds.includes(placementId)) {
                buildPlacementIdsOperation();
                break;
            }
        }
    }
    // city Ids check
    const buildCityIdsOperation = () => {
        updations.cityIds = updatedCampaign.cityIds;
    };
    if (updatedCampaign.cityIds.length !== campaign.cityIds.length) {
        buildCityIdsOperation();
    }
    else {
        for (const cityId of updatedCampaign.cityIds) {
            if (!campaign.cityIds.includes(cityId)) {
                buildCityIdsOperation();
                break;
            }
        }
    }
    // adGroupCityIds check
    const buildAdGroupCityIdsOperation = () => {
        updations.adGroupsCityIds = [
            {
                adGroupId: campaign.adGroups[0].id,
                cityIds: updatedCampaign.adGroups[0].cityIds,
            },
        ];
    };
    if (updatedCampaign.adGroups[0].cityIds.length !==
        campaign.adGroups[0].cityIds.length) {
        buildAdGroupCityIdsOperation();
    }
    else {
        for (const cityId of updatedCampaign.adGroups[0].cityIds) {
            if (!campaign.adGroups[0].cityIds.includes(cityId)) {
                buildAdGroupCityIdsOperation();
                break;
            }
        }
    }
    // mealSlots check
    const buildMealSlotOperation = () => {
        updations.adGroupsMealSlots = [
            {
                adGroupId: campaign.adGroups[0].id,
                mealSlots: updatedCampaign.adGroups[0].mealSlots,
            },
        ];
    };
    if (updatedCampaign.adGroups[0].mealSlots.length !==
        campaign.adGroups[0].mealSlots.length) {
        buildMealSlotOperation();
    }
    else {
        for (const mealSlot of updatedCampaign.adGroups[0].mealSlots) {
            if (!campaign.adGroups[0].mealSlots.includes(mealSlot)) {
                buildMealSlotOperation();
                break;
            }
        }
    }
    // daysOfWeek check
    const buildDaysOfWeekOperation = () => {
        updations.adGroupsDaysOfWeek = [
            {
                adGroupId: campaign.adGroups[0].id,
                daysOfWeek: updatedCampaign.adGroups[0].daysOfWeek,
            },
        ];
    };
    if (updatedCampaign.adGroups[0].daysOfWeek.length !==
        campaign.adGroups[0].daysOfWeek.length) {
        buildDaysOfWeekOperation();
    }
    else {
        for (const dayOfWeek of updatedCampaign.adGroups[0].daysOfWeek) {
            if (!campaign.adGroups[0].daysOfWeek.includes(dayOfWeek)) {
                buildDaysOfWeekOperation();
                break;
            }
        }
    }
    // keywords check
    const buildKeywordOperation = () => {
        updations.adGroupsKeywords = [
            {
                adGroupId: campaign.adGroups[0].id,
                keywords: updatedCampaign.adGroups[0].keywords,
            },
        ];
    };
    if (updatedCampaign.adGroups[0].keywords.length !==
        campaign.adGroups[0].keywords.length) {
        buildKeywordOperation();
    }
    else {
        for (const updatedKeyword of updatedCampaign.adGroups[0].keywords) {
            const { keywordText: updatedKeywordText, matchType: updatedKeywordMatchType, bid: updatedKeywordBid, } = updatedKeyword;
            const found = campaign.adGroups[0].keywords.find((keyword) => {
                const { keywordText: keywordText, matchType: keywordMatchType, bid: keywordBid, } = keyword;
                return (keywordText === updatedKeywordText &&
                    keywordMatchType === updatedKeywordMatchType &&
                    keywordBid === updatedKeywordBid);
            });
            if (!found) {
                buildKeywordOperation();
                break;
            }
        }
    }
    return updations;
}
